import LinkModel from './LinkModel';

export default class BannerClickHyperLinkModel {
  constructor() {
    this.value = new LinkModel();

    this.editable = '';
  }
  getData(dataSource) {
    if (dataSource && Object.prototype.hasOwnProperty.call(dataSource, 'value')) {
      this.value.getData(dataSource.value ?? {});
    }
    if (dataSource && Object.prototype.hasOwnProperty.call(dataSource, 'editable')) {
      this.editable = dataSource.editable ?? this.editable;
    }

    return this;
  }
}
